function OfflineFileUploadModalController() {
  const ctrl = this;
  ctrl.$onInit = () => {
    ctrl.file = ctrl.resolve.file;
  };

  ctrl.ok = () => {
    ctrl.close({ $value: ctrl.type });
  };

  ctrl.cancel = () => {
    ctrl.dismiss();
  };
}

angular
  .module('offline.module')
  .controller('OfflineFileUploadModalController', OfflineFileUploadModalController);
